import ClientsAxios from "../../client-axios";
import { CustomerGroupsCreateRequest, CustomerGroupsListRequest } from "../../dto/request/master/customerGroupsMaster.type";
import { ResponseEntity } from "../../dto/response";

const { API_SERVER } = ClientsAxios;

export const FetchCustomerGroupsListService = async (payload: CustomerGroupsListRequest | {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('customer-group-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const CreateCustomerGroupsService = async (payload: CustomerGroupsCreateRequest, isUpdate: boolean = false) => {
    const responseEntity = new ResponseEntity<{message: string}>();
    try {
        const urlType = isUpdate ? 'update' : 'store';
        const response = await API_SERVER.post(`customer-group-master/${urlType}`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteCustomerGroupsService = async (payload: { id: number }) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('customer-group-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}